export default __webpack_public_path__ + "static/media/pc-remoney.91abb77d.png";